import { render } from "./OilRecoveryStation.vue?vue&type=template&id=193adcd6&scoped=true"
import script from "./OilRecoveryStation.vue?vue&type=script&lang=js"
export * from "./OilRecoveryStation.vue?vue&type=script&lang=js"

import "./OilRecoveryStation.vue?vue&type=style&index=0&id=193adcd6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-193adcd6"]])

export default __exports__